import { Box, styled } from '@mui/system'

export const TopbarStyled = styled(Box)(() => ({
    transition: '.2s all',
   padding: '0 88px 0 88px'
  }))
  
  